/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiAccountsPartialUpdateParams = zod.strictObject({
    format: zod.enum(['csv', 'json']).optional(),
});

export type ApiAccountsPartialUpdateParams = zod.input<
    typeof ApiAccountsPartialUpdateParams
>;
export type ApiAccountsPartialUpdateParamsOutput = zod.output<
    typeof ApiAccountsPartialUpdateParams
>;
